import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Answer from '../../entities/answer';
export function deleteAnswer(answer: Answer, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = answer.id;}
const _work = workingSet();




answer.status = 'D';
answer.addedOn = newHRTimestamp();
answer.addedBy = getCurrentUserId();
answer.importSource = targetImportSource;
answer.importId = mergeId;
store.dispatch(Actions.AnswerActions.removeAnswerQueue(answer));
}


